import { UseQueryOptions } from '@tanstack/react-query'
import {
    GetOffersResult,
    OfferVariantType,
} from '@west-australian-newspapers/subscription-offer-types'
import { consoleLogger } from '@west-australian-newspapers/typescript-log'
import { fetchSubscriptionOffers } from './get-subscription-offer-data'

export type OfferGroup = 'breach' | 'campaigns'

type BuildElectionDefinitionDefinitionArgs = {
    initialData?: GetOffersResult
    publicationId: string
    offerGroup: OfferGroup
    variant?: OfferVariantType
    config?: { subscriptionOfferApi?: string }
}

export const buildSubscriptionOfferDefinition = ({
    initialData,
    publicationId,
    offerGroup,
    variant,
    config,
}: BuildElectionDefinitionDefinitionArgs): UseQueryOptions<
    GetOffersResult,
    unknown,
    GetOffersResult,
    [
        'subscription-offer-api',
        string,
        OfferGroup,
        OfferVariantType | undefined,
        'definition',
    ]
> => {
    // Refetch after 1 minute for SSR else 5 minutes
    const dataFrequency = initialData ? 1 * 60 * 1000 : 5 * 60 * 1000
    const log = consoleLogger()

    return {
        queryKey: [
            'subscription-offer-api',
            publicationId,
            offerGroup,
            variant,
            'definition',
        ],
        queryFn: async (): Promise<GetOffersResult> => {
            const subscriptionOfferData = await fetchSubscriptionOffers(
                publicationId,
                log,
                offerGroup,
                variant,
                config,
            )
            // Override SSR data with fresh query results
            return { ...initialData, ...subscriptionOfferData }
        },
        onError: (error) => {
            log.error(
                { error },
                '[Subscription Offer API] Failed to fetch from Offers API',
            )
            throw new Error('Something went wrong. Please try again later.')
        },
        // Only provide initial data when the server preloaded it.
        ...(initialData ? { initialData } : {}),
        staleTime: dataFrequency,
        refetchInterval: dataFrequency,
        refetchOnWindowFocus: 'always',
    }
}
